const RE_TRACE_ID_RESERVED = /[;]/g;

export const makeTraceId = (traceFieldName: string, url: URL): string => {
  let page = url.href.slice(url.origin.length);
  page = page.slice(0, 512);
  page = page.replaceAll(RE_TRACE_ID_RESERVED, (s) => encodeURIComponent(s));
  return `${traceFieldName}=${page}`;
};
